// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"EditExternalIntegrationVariables_saveButton__VMnQD"};